/* eslint-disable */
import { mergeStoreDraft } from "../../utils/storeDraft";
const Fetch_STORE = "Fetch_STORE";

const initialState = "";

export const applyStoreDraft = (source, draft) => ({
  type: "Apply_STORE_DRAFT",
  payload: { source, draft },
});

export const fetchStore = (payload) => ({
  type: Fetch_STORE,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "Apply_STORE_DRAFT":
      if (state?.id !== action.payload.source?.id) return state;
      return mergeStoreDraft(state, action.payload.source, action.payload.draft);
    case Fetch_STORE:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;

